package com.ives.components.main;

import com.ives.components.notifier.Notifier;
import js.html.TouchEvent;
import js.Browser;
import js.html.AnimationEvent;
import js.html.MutationRecord;
import js.html.MutationObserver;

import com.er453r.hxcompo.Component;

import com.ives.components.productlabel.ProductLabel;
import com.ives.components.viewer.DicomViewer;
import com.ives.components.browse.DicomBrowse;
import com.ives.utils.Version;
import com.ives.utils.Translator;
import com.ives.utils.Remoting;
import com.ives.utils.Config;
import com.ives.utils.Log;
import com.ives.utils.ButtonGroup;
import com.ives.utils.Capabilities;
import com.ives.components.messagehandler.MessageHandler;
import com.ives.modules.ModuleEvent;

class Main extends Component {
	private var messageHandler:MessageHandler = new MessageHandler();
	private var notifier:Notifier = new Notifier();

	private var observer:MutationObserver;

	private var firstBoot:Bool = true;
	private var externalEvent:Bool = false;
	private var dicomViewer:DicomViewer;

	public static function main(){
		if(Config.DEBUG)
			Log.level = LogLevel.DEBUG;

		Translator.traslateTo(Translator.LANG_PL);

		Capabilities.isSupportedBrowser();
	}

	public function new (){
		Log.debug('Server url is ${Config.SERVER_URL}');
		Log.debug('Git revision: ${Version.getGitCommitHash()}');

		if(!Capabilities.supportedBrowser)
			unsupportedBrowser.style.display = "block";

		if(Config.TEST)
			testOnly.style.display = "block";

		Remoting.serverUrl = '${Config.SERVER_URL}/';

		invisium.addEventListener("animationend", init);

		observer = new MutationObserver(onDOMChange);
		observer.observe(view, {childList:true, subtree: true});

		on(DicomViewer.VIEWER_CLOSE, onViewerClose);

		Browser.window.addEventListener("resize", onResize);

		onResize();

		Browser.document.body.addEventListener("touchstart", function(event:TouchEvent){}); // this seems to be required for safari iOS

		viewElement.appendChild(messageHandler.viewElement);
		viewElement.appendChild(notifier.viewElement);
	}

	private function onResize(){
		if(Capabilities.isMobileBrowser())
			viewElement.classList.add("mobile");
		else
			viewElement.classList.remove("mobile");
	}

	private function onDOMChange(mutations:Array<MutationRecord>, observer:MutationObserver){
		observer.disconnect(); // has to disconnect, or it will loop

		ButtonGroup.init();
		Translator.translate();

		observer.observe(view, {childList:true, subtree: true});
	}

	private function init(animation:AnimationEvent){
		if(animation.animationName != "logo")
			return;

		if(Config.BROWSING_ENABLED)
			append(new DicomBrowse());

		if(firstBoot){
			on("studySelected", onSelectEvent);

			on(MessageHandler.LOAD, onLoadFromMessage);
			on(MessageHandler.CLOSE, onCloseFromMessage);
			on(MessageHandler.VIEWER, onViewerMessage);

			new ProductLabel().open();

			firstBoot = false;

			MessageHandler.sendReady();
		}
	}

	private function onSelectEvent(dicomImageData:DicomImageData){
		clear();

		invisium.classList.add("hidden");
		ives.classList.add("hidden");

		if(!externalEvent)
			MessageHandler.sendMessage(new MessageData(MessageHandler.LOAD, dicomImageData.id, dicomImageData.sourceName));

		externalEvent = false;

		dicomViewer = new DicomViewer(dicomImageData);

		append(dicomViewer);
	}

	private function onViewerClose(){
		clear();

		if(!externalEvent)
			MessageHandler.sendMessage(new MessageData(MessageHandler.CLOSE));

		externalEvent = false;

		invisium.classList.remove("hidden");
		ives.classList.remove("hidden");
	}

	private function onCloseFromMessage(messageData:MessageData){
		Log.debug('Closing form message');

		externalEvent = true;

		onViewerClose();
	}

	private function onLoadFromMessage(messageData:MessageData){
		Log.debug('Loading image data for ${messageData}');

		Remoting.getDicomImageData(messageData.source, messageData.id, onDicomImageData);
	}

	private function onDicomImageData(dicomImageData:DicomImageData){
		Log.debug('Image data loaded!');

		externalEvent = true;

		onSelectEvent(dicomImageData);
	}

	private function onViewerMessage(event:ModuleEvent){
		dicomViewer.onEventFromModule(event);
	}
}
